interface DiamondIconProps {
  color?: string;
  className?: string;
  onClick?: () => void;
  size?: number;
}

function DiamondIcon({ color, className, onClick, size }: DiamondIconProps) {
  return (
    <svg
      width={size || 40}
      height={size || 40}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        d="M54.5429 22.865L48.2518 11.7098C47.9447 11.1654 47.4985 10.7125 46.9588 10.3973C46.4191 10.0821 45.8053 9.916 45.1803 9.91602H14.8178C14.193 9.91621 13.5794 10.0824 13.04 10.3976C12.5005 10.7128 12.0544 11.1656 11.7474 11.7098L5.45513 22.865C5.07668 23.5358 4.92822 24.312 5.03244 25.0751C5.13666 25.8382 5.48783 26.5462 6.03229 27.0909L28.3369 49.3955C28.7778 49.8362 29.3757 50.0838 29.999 50.0838C30.6224 50.0838 31.2203 49.8362 31.6612 49.3955L53.967 27.0897C54.5116 26.5451 54.863 25.8372 54.9674 25.0741C55.0719 24.311 54.9236 23.5348 54.5453 22.8639L54.5429 22.865Z"
        stroke={color || 'var(--black)'}
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.8548 9.91602L20.3801 23.7161C20.1379 24.6788 20.2066 25.6935 20.5764 26.6148L29.9896 50.0843H30.0096"
        stroke={color || 'var(--black)'}
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.1432 9.91602L39.6168 23.7161C39.8593 24.6787 39.791 25.6934 39.4216 26.6148L30.0084 50.0843"
        stroke={color || 'var(--black)'}
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.31406 25.1973H54.684"
        stroke={color || 'var(--black)'}
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default DiamondIcon;
